import _styled from "@emotion/styled-base";

var _templateObject;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import { css, keyframes } from "@emotion/core";
import * as React from "react";
import { ChevronDown, X } from "react-feather";
import { Reference } from "react-popper";
import tinycolor from "tinycolor2";
import { remRhythm } from "../css";
import LoadingIcon from "../LoadingIcon";
import { Span } from "../Text";
import { jsx as ___EmotionJSX } from "@emotion/core";

function createGlowingAnimation(theme) {
  return keyframes(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    0% {\n      box-shadow: 0 0 1px ", ";\n    }\n\n    50% {\n      box-shadow: 0 0 10px ", ";\n    }\n\n    100% {\n      box-shadow: 0 0 1px ", ";\n    }\n  "])), theme.colors.blue, theme.colors.blue, theme.colors.blue);
}

var sharedTriggerStyles = [function (_ref2) {
  var theme = _ref2.theme,
      gray = _ref2.gray;
  var borderColor = theme.colors.rule;
  var backgroundColor = gray ? theme.colors.grays[25] : theme.colors.white;
  return /*#__PURE__*/css("label:base;background-color:", backgroundColor, ";display:inline-block;width:100%;min-height:calc(", remRhythm(1 + 1 / 4), " + 2px);margin:0;padding:", remRhythm(1 / 8), " ", remRhythm(1 + 1 / 8), " ", remRhythm(1 / 8), " ", remRhythm(3 / 8), ";border:1px solid ", theme.colors.rule, ";border-radius:", theme.radii.md, ";box-shadow:0 2px 0 ", theme.colors.rule, ";color:", theme.colors.heading, ";font-size:1rem;font-weight:normal;font-family:", theme.fonts.text, ";text-align:left;text-decoration:none;vertical-align:middle;outline:none;transition-timing-function:ease-out;transition-duration:500ms;transition-property:border-color,box-shadow,background,box-shadow;&:hover{border-color:", tinycolor(borderColor).darken(15).toString(), ";box-shadow:0 2px 0 ", tinycolor(borderColor).darken(15).toString(), ";transition-duration:200ms;}&:focus{border-color:", theme.colors.blueHover, ";box-shadow:0px 0px 1px 1px ", tinycolor(theme.colors.blueHover).setAlpha(0.5).toString(), ";transition-duration:200ms;}");
}, function (_ref3) {
  var isOpen = _ref3.isOpen,
      theme = _ref3.theme;
  return isOpen && /*#__PURE__*/css("label:is-open;border-color:", theme.colors.blue, ";border-radius:", theme.radii.md, " ", theme.radii.md, " 0 0;background:white;");
}, function (_ref4) {
  var menuPlacement = _ref4.menuPlacement,
      isOpen = _ref4.isOpen,
      theme = _ref4.theme;
  return isOpen && menuPlacement && menuPlacement.indexOf("top") === 0 && /*#__PURE__*/css("label:is-open-top;border-radius:0 0 ", theme.radii.md, " ", theme.radii.md, ";");
}, function (_ref5) {
  var requireAction = _ref5.requireAction,
      isOpen = _ref5.isOpen,
      theme = _ref5.theme;
  return requireAction && !isOpen && /*#__PURE__*/css("label:require-action;animation:", createGlowingAnimation(theme), " 2s infinite;z-index:1;");
}];

var ComboxboxTriggerButton = /*#__PURE__*/_styled("button", {
  target: "e7b76pm0"
}).apply(void 0, sharedTriggerStyles.concat([{
  name: "la7dzu-base-button",
  styles: "label:base-button;cursor:pointer;"
}]));

ComboxboxTriggerButton.displayName = "ComboxboxTriggerButton";

var ComboxboxTriggerInput = /*#__PURE__*/_styled("input", {
  target: "e7b76pm1"
}).apply(void 0, sharedTriggerStyles.concat([function (_ref6) {
  var theme = _ref6.theme;
  return /*#__PURE__*/css("label:base-input;&::placeholder{color:", theme.colors.muted, ";}");
}]));

ComboxboxTriggerInput.displayName = "ComboxboxTriggerInput";
var sharedIndicatorStyles = /*#__PURE__*/css("label:shared-indicator-styles;position:absolute;top:50%;right:1px;width:", remRhythm(1 + 1 / 4), ";height:", remRhythm(1 + 1 / 4), ";margin:0;padding:0;display:flex;align-items:center;justify-content:center;transform:translateY(-50%);");

var ComboboxTriggerIndicator = /*#__PURE__*/_styled("div", {
  target: "e7b76pm2"
})(sharedIndicatorStyles);

var toggleIconStyle = function toggleIconStyle(_ref7) {
  var theme = _ref7.theme;
  return /*#__PURE__*/css("label:base;color:", theme.colors.muted, ";border:0;background:none;box-shadow:none;outline:none;transition:all 250ms ease-out;cursor:pointer;&:hover{color:$blue;}&:disabled{color:", theme.colors.muted, ";cursor:default;cursor:not-allowed;}");
};

var _ref = {
  name: "1t2bcjg-is-open",
  styles: "label:is-open;transform:translateY(-50%) rotate(180deg);"
};

var ComboboxTriggerToggle = /*#__PURE__*/_styled("button", {
  target: "e7b76pm3"
})(sharedIndicatorStyles, toggleIconStyle, function (_ref8) {
  var isOpen = _ref8.isOpen;
  return isOpen && _ref;
});

var ComboboxClearSelectionToggle = /*#__PURE__*/_styled("button", {
  target: "e7b76pm4"
})(sharedIndicatorStyles, toggleIconStyle);

var ComboboxTrigger = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ComboboxTrigger, _React$Component);

  function ComboboxTrigger() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ComboboxTrigger.prototype;

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        allowClear = _this$props.allowClear,
        placeholder = _this$props.placeholder,
        disabled = _this$props.disabled,
        loading = _this$props.loading,
        gray = _this$props.gray,
        requireAction = _this$props.requireAction,
        isOpen = _this$props.isOpen,
        disableSearch = _this$props.disableSearch,
        menuPlacement = _this$props.menuPlacement,
        focusableRef = _this$props.focusableRef,
        selectedItem = _this$props.selectedItem,
        toggleMenu = _this$props.toggleMenu,
        clearSelection = _this$props.clearSelection,
        getInputProps = _this$props.getInputProps,
        getToggleButtonProps = _this$props.getToggleButtonProps,
        renderSelected = _this$props.renderSelected;

    var selectIcon = function selectIcon() {
      if (loading) {
        return ___EmotionJSX(ComboboxTriggerIndicator, null, ___EmotionJSX(LoadingIcon, {
          size: "1em"
        }));
      }

      if (selectedItem && allowClear) {
        return ___EmotionJSX(ComboboxClearSelectionToggle, {
          type: "button",
          tabIndex: -1,
          disabled: disabled,
          onClick: function onClick() {
            return clearSelection();
          },
          gray: !!gray
        }, ___EmotionJSX(X, {
          size: "1em"
        }));
      }

      return ___EmotionJSX(ComboboxTriggerToggle, _extends({
        type: "button"
      }, getToggleButtonProps(), {
        tabIndex: -1,
        disabled: disabled,
        gray: gray,
        isOpen: isOpen
      }), ___EmotionJSX(ChevronDown, {
        size: "1em"
      }));
    };

    return ___EmotionJSX(Reference, null, function (refProps) {
      return ___EmotionJSX("div", {
        ref: refProps.ref
      }, disableSearch ? ___EmotionJSX(ComboxboxTriggerButton, _extends({
        type: "button"
      }, getToggleButtonProps(), {
        disabled: disabled,
        gray: gray,
        requireAction: requireAction,
        isOpen: isOpen,
        ref: focusableRef,
        menuPlacement: menuPlacement
      }), selectedItem ? renderSelected(_this.props) : ___EmotionJSX(Span, {
        textColor: "muted"
      }, placeholder || "")) : ___EmotionJSX(ComboxboxTriggerInput, _extends({}, getInputProps(), {
        type: "text",
        placeholder: placeholder,
        disabled: disabled,
        gray: gray,
        requireAction: requireAction,
        isOpen: isOpen,
        onClick: function onClick() {
          return toggleMenu();
        },
        ref: focusableRef,
        menuPlacement: menuPlacement,
        autoCorrect: "off",
        spellCheck: "false"
      })), selectIcon());
    });
  };

  return ComboboxTrigger;
}(React.Component);

ComboboxTrigger.defaultProps = {
  allowClear: false,
  disabled: false,
  loading: false,
  gray: false,
  requireAction: false,
  isOpen: false,
  disableSearch: false
};
export { ComboboxTrigger as default };